<template>
  <el-select
    v-model="keyword"
    size="mini"
    filterable
    remote
    clearable
    reserve-keyword
    placeholder="可搜索房产/客户姓名"
    :remote-method="remoteMethod"
    :loading="loading"
  >
    <el-option
      v-for="item in selectList"
      :key="item.id"
      :label="item.house"
      :value="item.house"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  // 房产搜索组件
  name: "HouseSearch",
  props: {
    search: {
      type: String,
      default: "",
    },
    project_id: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      selectList: [],
      loading: false,
      keyword: "",
    };
  },
  mounted() {},
  watch: {
    selectList(e) {
      this.$emit("selectListChange", e);
    },
    keyword(e) {
      this.$emit("update:search", e);
    },
  },
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp
          .get(
            "admin/common/house_text?text=" +
              query +
              "&project_id=" +
              this.project_id,
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.selectList = [];
      }
    },
  },
};
</script>

<style>
@import "../../assets/css/table.css";
</style>


// WEBPACK FOOTER //
// src/components/common/houseSearch.vue